import React from "react";
import styled from "styled-components";
import { theme } from "../theme";
import {
  FaWhatsapp,
  FaEnvelope,
  FaFacebook,
  FaPhone,
  FaUser,
} from "react-icons/fa";
import { TbBrandTiktok } from "react-icons/tb"; // Import TikTok icon
import drivingGif from "../PhotosGallery/10.webp";

const Container = styled.div`
  color: ${theme.colors.primary};
  min-height: 70vh;
  padding: 20px; // General padding
  display: flex;
  flex-direction: column; // Stack elements vertically
  align-items: center; // Center align items
  justify-content: center;
  text-align: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  @media (max-width: 768px) {
    padding: 10px; // Adjust padding for smaller screens
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 20px; // Reduced bottom margin for better spacing
  z-index: 10;
`;

const ContactInfo = styled.div`
  font-size: 1.5rem;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center; // Center align items
  gap: 18px; // Space between items
  padding: 0; // Remove left padding

  @media (max-width: 768px) {
    align-items: center; // Center align items for mobile
    font-size: 1.2rem; // Reduce font size for better readability
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  color: ${theme.colors.primary};
  z-index: 10;
  width: 100%; // Ensure it uses full width
  justify-content: left; // Center content

  @media (max-width: 768px) {
    flex-direction: column; // Stack icons and text vertically
    align-items: center; // Center align items
    text-align: center; // Center text for mobile view
  }
`;

const Icon = styled.div`
  font-size: 2.1rem;
  color: ${theme.colors.primary};
  margin-right: 10px;
  z-index: 10;
`;

const LinkText = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const GIFContainer = styled.div`
  width: 18%;
  height: auto;

  display: flex;
  justify-content: center;
  align-items: center; // Center the image

  & img {
    max-width: 100%;
    height: auto;
    filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.7));
    border-radius: 15px; // Rounded corners
    opacity: 0.95; // Slight transparency
    object-fit: cover; // Cover the area without distortion
    animation: img-shine 3s infinite alternate; // Keep animation for small screens

    @keyframes img-shine {
      0% {
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 10px rgba(212, 175, 55, 0.7);
      }
      100% {
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
          0 0 20px rgba(212, 175, 55, 0.9), 0 0 30px rgba(212, 175, 55, 0.8);
      }
    }
  }
`;

const Contacts: React.FC = () => {
  return (
    <Container>
      <Title>Contactinformatie</Title>
      <ContactInfo>
        <ContactItem>
          <Icon>
            <FaUser />
          </Icon>
          <span>Trainer: Jangin Shekho</span>
        </ContactItem>
        <ContactItem>
          <Icon>
            <FaPhone />
          </Icon>
          <div>
            <LinkText href="tel:0684629633">0684629633</LinkText>
            {" - "}
            <LinkText href="tel:0628570565">0628570565</LinkText>
          </div>
        </ContactItem>
        <ContactItem>
          <Icon>
            <FaWhatsapp />
          </Icon>
          <LinkText
            href="https://wa.me/0684629633"
            target="_blank"
            rel="noopener noreferrer"
          >
            0684629633
          </LinkText>
        </ContactItem>
        <ContactItem>
          <Icon>
            <FaEnvelope />
          </Icon>
          <LinkText href="mailto:best.rijschool@gmail.com">
            best.rijschool@gmail.com
          </LinkText>
        </ContactItem>
        <ContactItem>
          <Icon>
            <FaFacebook />
          </Icon>
          <LinkText
            href="https://www.facebook.com/profile.php?id=61561621694605"
            target="_blank"
            rel="noopener noreferrer"
          >
            Best Rijschool
          </LinkText>
        </ContactItem>
        <ContactItem>
          <Icon>
            <TbBrandTiktok /> {/* Add TikTok icon */}
          </Icon>
          <LinkText
            href="https://www.tiktok.com/@best.rijschool" // TikTok link
            target="_blank"
            rel="noopener noreferrer"
          >
            best.rijschool
          </LinkText>
        </ContactItem>
      </ContactInfo>
    </Container>
  );
};

export default Contacts;
